export const flex = {
  horizontal: `
    display: flex;
    flexDirection: row;
  `,
  vertical: `
    display: flex;
    flexDirection: column;
  `,
  flexWrap: `
    display: flex;
    flexWrap: wrap;
  `,
  centerHorizontal: `
    justifyContent: center;
    alignItems: center;
  `,
  wrap: `
    flexWrap: wrap;
  `,
  centerHorizontalH: `
    justifyContent: center;
  `,
  centerHorizontalV: `
    alignItems: center;
  `,
  centerVertical: `
    alignItems: center;
    justifyContent: center;
  `,
  centerVerticalReset:`
    alignItems: initial;
    justifyContent: initial;
  `,
  centerVerticalH: `
    alignItems: center;
  `,
  centerVerticalV: `
    justifyContent: center;
  `,
  spaceAround: `
    justifyContent: space-around;
  `,
  spaceBetween: `
    justifyContent: space-between;
  `,
  justifyEnd: `
    justifyContent: flex-end;
  `
};

export default flex;



// WEBPACK FOOTER //
// ./src/styles/flex.js